import type { CustomValues } from '@atlassian/browser-metrics/types';

export const ssrRegionPlugin = (): CustomValues => {
	const customAttributes: CustomValues = {
		ssrRegion: window.__SSR_REGION__ ?? '',
	};
	return customAttributes;
};
